<template>
<div id="app">

  <router-view name="headers"></router-view>
  <router-view name="banner"></router-view>
  <router-view name="value"></router-view>
  <router-view name="culture"></router-view>
  <router-view name="footer"></router-view>
  <router-view name="transparentheaders"></router-view>
  <router-view name="registerbackground"></router-view>
  <router-view name="loginbackground"></router-view>
  <router-view name="job"></router-view>
  <router-view name="about"></router-view>
  <router-view name="price"></router-view>
  <router-view name="friend"> </router-view>
  <router-view name="moments"></router-view>
  <router-view name="mycenter" :key="$route.fullPath"></router-view>
  <router-view name="judge"></router-view>
  <router-view name="companyverify"></router-view>
  <router-view name="nameverify"></router-view>
  <router-view name="notice"></router-view>
  <router-view name="kefu"></router-view>
  <router-view name="jobintro"></router-view>
  <router-view name="useragreement"></router-view>
  <router-view name="privateagree"></router-view>
  <audio source controls="controls" hidden src="./assets/audios/y1479.mp3" id="my_audio" type="audio/mpeg" autoplay> </audio>

</div>
</template>

<script>
import request from './utils/request';

// import audio from './assets/audios/y1479.mp3'
export default {
  name: 'app',
  data() {
    return {
      userid: "",
      audioSrc: "",
      src: "",

    }
  },
  create() {
    request({
      method: 'GET',
      url: '/propertyList',
      params: {
        test: '111',
        hello: 'world'
      },

    })
  },
  mounted() {
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id
    //   var websocket = null;
    //   var userId = JSON.parse(
    //     sessionStorage.getItem("userinfo_Data")
    //   ).id
    //   if ('WebSocket' in window) {
    //     websocket = new WebSocket("ws://124.221.125.59:9701/jeecg-boot/websocketRingStar/" + userId);

    //   } else {
    //     alert('当前浏览器 Not support websocket')
    //   }

    //   //连接发生错误的回调方法
    //   websocket.onerror = function () {
    //     console.log("WebSocket连接发生错误");
    //   };
    //   //连接成功建立的回调方法
    //   websocket.onopen = function connectWebSocket() {
    //     console.log("WebSocket连接成功");
    //   }

    //   //接收到消息的回调方法
    //   websocket.onmessage = (event) => {
    //     console.log(event.data);
    //     this.someValue = event.data
    //     //  this.playAudio()
    //     let buttonAudio = document.getElementById('my_audio');
    //       var audio = require('./assets/audios/y1479.mp3')
    // buttonAudio.setAttribute('src', audio)
    // buttonAudio.play()
    //   }
  },
  methods: {

  }
}
</script>

<style>
@import './assets/css/base.css';
</style>



// WEBPACK FOOTER //
// src/App.vue